!function(e,t){"object"==typeof exports&&"object"==typeof module?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.storeblocks=t():e.storeblocks=t()}(self,(()=>(()=>{"use strict";var e={546:(e,t,o)=>{o.d(t,{ButtonWrapper:()=>u,Content:()=>s,Description:()=>p,Header:()=>c,PopoverBase:()=>l,Popper:()=>a});const r=require("styled-components");var n=o.n(r);const i=require("styled-system"),l=n().div`
  align-items: center;
  display: flex;
  font-family: 'Open Sans', sans-serif;
  flex-shrink: 0;
  height: 48px;
  justify-content: center;
  line-height: 24px;
  width: 48px;

  & > button:focus {
    outline: var(--outline);
    outline-offset: 4px;
  }

  & > button:focus:not(:focus-visible) {
    outline: 0;
  }

  & > button:focus-visible {
    outline: var(--outline);
    outline-offset: 4px;
  }

  & > button > i {
    color: var(--color-on-background);
  }

  ${i.space};
`,a=n().div`
  display: flex;
  background: var(--color-on-background);
  color: var(--color-background);
  flex-direction: row;
  gap: 16px;
  justify-content: space-between;
  min-width: 288px;
  max-width: 560px;
  padding: 32px;
  z-index: 100;

  & i {
    color: var(--color-background);
  }
`,s=n().div`
  display: flex;
  flex-direction: column;
`,c=n().div`
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 16px;
`,u=n().div`
  margin-top: 1px;
`,p=n().div`
  & .system-icon {
    color: var(--color-background);
  }

  & a {
    color: var(--color-background);
  }
`}},t={};function o(r){var n=t[r];if(void 0!==n)return n.exports;var i=t[r]={exports:{}};return e[r](i,i.exports,o),i.exports}o.n=e=>{var t=e&&e.__esModule?()=>e.default:()=>e;return o.d(t,{a:t}),t},o.d=(e,t)=>{for(var r in t)o.o(t,r)&&!o.o(e,r)&&Object.defineProperty(e,r,{enumerable:!0,get:t[r]})},o.o=(e,t)=>Object.prototype.hasOwnProperty.call(e,t),o.r=e=>{"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})};var r={};return(()=>{o.r(r),o.d(r,{Popover:()=>s,default:()=>c});const e=require("react");var t=o.n(e);const n=require("@floating-ui/react"),i=require("@storeblocks/button");var l=o.n(i),a=o(546);const s=(0,e.forwardRef)(((o,r)=>{var{title:i="",placement:s="right",icon:c="information",showOn:u="press",size:p=16,children:d,buttonProps:f,iconColor:b,closeButtonAriaLabel:y="Close | Lukk"}=o,v=function(e,t){var o={};for(var r in e)Object.prototype.hasOwnProperty.call(e,r)&&t.indexOf(r)<0&&(o[r]=e[r]);if(null!=e&&"function"==typeof Object.getOwnPropertySymbols){var n=0;for(r=Object.getOwnPropertySymbols(e);n<r.length;n++)t.indexOf(r[n])<0&&Object.prototype.propertyIsEnumerable.call(e,r[n])&&(o[r[n]]=e[r[n]])}return o}(o,["title","placement","icon","showOn","size","children","buttonProps","iconColor","closeButtonAriaLabel"]);const[m,g]=(0,e.useState)(!1),x=(0,e.useCallback)((()=>g(!m)),[m]),h=(0,e.useCallback)((()=>g(!1)),[]),{x:O,y:k,reference:j,floating:P,strategy:w,context:C}=(0,n.useFloating)({open:m,onOpenChange:g,whileElementsMounted:n.autoUpdate,middleware:[(0,n.shift)(),(0,n.offset)(8),(0,n.hide)(),(0,n.flip)({fallbackPlacements:["left","top","bottom"]})],placement:s,strategy:"fixed"}),{getReferenceProps:E,getFloatingProps:S}=(0,n.useInteractions)([(0,n.useRole)(C),(0,n.useDismiss)(C),(0,n.useHover)(C,{enabled:"hover"===u})]),{isMounted:B,styles:q}=(0,n.useTransitionStyles)(C,{duration:200}),z=(0,n.useId)(),I=(0,n.useId)(),L=(0,n.useId)();return t().createElement(a.PopoverBase,Object.assign({},v,{ref:r}),t().createElement(l(),Object.assign({"aria-label":c,type:"button",variant:"icon",iconLeft:c,color:b,size:p,onClick:x},f,{ref:j},E())),B&&t().createElement(a.Popper,Object.assign({id:z},S({ref:P,style:Object.assign({position:w,top:null!=k?k:0,left:null!=O?O:0},q),"aria-labelledby":i?I:L,"aria-describedby":L})),t().createElement(a.Content,null,i&&t().createElement(a.Header,{id:I},i),t().createElement(a.Description,{id:L},d)),"press"===u&&t().createElement(a.ButtonWrapper,null,t().createElement(l(),{"aria-label":y,type:"button",variant:"icon",iconLeft:"close",onClick:h}))))})),c=s})(),r})()));
//# sourceMappingURL=index.js.map